import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

const CodeBlock = styled(Box)(({ theme }) => ({
  fontFamily: 'monospace',
  fontSize: '0.875rem',
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.grey[100],
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  overflow: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
}))

export default CodeBlock
